// 权限指令 - 简化版本，适配个人门户
import type { Directive } from 'vue'

// v-hasPermi 指令 - 在个人门户中所有用户都有权限
export const hasPermi: Directive = {
  mounted(el, binding) {
    // 个人门户不需要复杂的权限控制，所有用户都可以访问自己的数据
    // 如果需要权限控制，可以在这里添加逻辑
    const { value } = binding
    if (value && Array.isArray(value) && value.length === 0) {
      el.parentNode?.removeChild(el)
    }
  },
}

export default {
  hasPermi,
}
